module.exports = __webpack_public_path__ + "img/softnext.40a46db1.jpg";